/* MIST header enhancements (2026-10-13, preview): hover-open mega menu, typed search hint, collection description clamp. */
(function () {
  // 1. Mega menu opens on hover (desktop, real pointer). Click still works; Esc closes (Dawn).
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  function bindHover() {
    if (!fine.matches) return;
    document.querySelectorAll('.mega-menu-bar details.mega-menu').forEach(function (d) {
      if (d.dataset.mistHover) return;
      d.dataset.mistHover = '1';
      var t;
      var li = d.closest('li') || d;
      li.addEventListener('mouseenter', function () {
        clearTimeout(t);
        document.querySelectorAll('.mega-menu-bar details.mega-menu[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
        d.setAttribute('open', '');
      });
      li.addEventListener('mouseleave', function () {
        t = setTimeout(function () { d.removeAttribute('open'); }, 160);
      });
    });
  }

  // 1b. Top-level items are links on desktop: click goes to the collection (hover already shows the dropdown).
  function bindClicks() {
    if (!fine.matches) return;
    document.querySelectorAll('.mega-menu-bar summary[data-href]').forEach(function (s) {
      if (s.dataset.mistClick) return;
      s.dataset.mistClick = '1';
      s.style.cursor = 'pointer';
      s.addEventListener('click', function (e) {
        var href = s.getAttribute('data-href');
        // Mouse clicks navigate; keyboard (Enter/Space, detail 0) keeps Dawn's toggle so the dropdown stays reachable.
        if (!href || href === '#' || e.detail === 0) return;
        e.preventDefault();
        window.location.href = href;
      });
    });
  }

  // 2. Typed search hint on a loop. Runs only while the field is on screen, the tab is visible, the field is
  //    empty and unfocused, and the visitor hasn't asked for reduced motion. Hints: data-hints="a|b|c" or the defaults.
  var hints = ['MIST Originals', 'Menthol 10ml', 'Nic salts', 'Uwell Caliburn', 'Replacement coils', 'Shortfills'];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function typeLoop(input) {
    if (input.dataset.mistType) return;
    input.dataset.mistType = '1';
    var words = (input.getAttribute('data-hints') || '').split('|').filter(Boolean);
    if (!words.length) words = hints;
    var original = input.placeholder;
    var i = 0, j = 0, del = false, timer = null, inView = !('IntersectionObserver' in window);
    function running() { return inView && !document.hidden && !reduce.matches && document.activeElement !== input && !input.value; }
    function tick() {
      var word = words[i];
      j += del ? -1 : 1;
      input.placeholder = 'Search ' + word.slice(0, j);
      var wait = del ? 35 : 75;
      if (!del && j === word.length) { del = true; wait = 1600; }
      else if (del && j === 0) { del = false; i = (i + 1) % words.length; wait = 350; }
      timer = setTimeout(tick, wait);
    }
    function update() {
      if (running()) { if (!timer) timer = setTimeout(tick, 350); return; }
      clearTimeout(timer); timer = null;
      if (document.activeElement === input || input.value) input.placeholder = 'Search e-liquids, kits, coils…';
      else if (reduce.matches) input.placeholder = original;
    }
    if (!inView) new IntersectionObserver(function (entries) { inView = entries[entries.length - 1].isIntersecting; update(); }).observe(input);
    ['focus', 'blur', 'input'].forEach(function (ev) { input.addEventListener(ev, update); });
    document.addEventListener('visibilitychange', update);
    if (reduce.addEventListener) reduce.addEventListener('change', update);
    update();
  }
  // 3. Collection description: clamp to 3 lines with a Read more / Read less toggle (only when it overflows).
  //    Re-measured after web fonts load and on resize.
  function bindClamp() {
    document.querySelectorAll('.mist-clamp').forEach(function (box) {
      var btn = box.parentElement.querySelector('.mist-clamp__toggle');
      if (!btn || btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var measure = function () { if (!box.classList.contains('is-open')) btn.hidden = box.scrollHeight <= box.clientHeight + 4; };
      var t;
      measure();
      if (document.fonts) document.fonts.ready.then(measure);
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(measure, 150); });
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Read less' : 'Read more';
      });
    });
  }

  function init() {
    bindHover();
    bindClicks();
    bindClamp();
    document.querySelectorAll('.header-wrapper input[type="search"], .mist-msearch__input').forEach(typeLoop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
